var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"popular-pages"}},[_c('card',{attrs:{"icon":"eye","headline":_vm.$t('visitors.topPages.headline'),"description":_vm.$t('visitors.topPages.description')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }